import { FeedbackButton as FeedbackButtonStyled, FeedbackTag } from "./styled";

export function FeedbackButtonView({ url, onClick }) {
  return (
    <FeedbackButtonStyled href={url} onClick={onClick} target="_blank">
      <FeedbackTag>UX</FeedbackTag> Оставить отзыв
    </FeedbackButtonStyled>
  );
}
